import { render, staticRenderFns } from "./historical-breakeven-details-inquiry.vue?vue&type=template&id=2084e0d6&"
import script from "./historical-breakeven-details-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-breakeven-details-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports